import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { H, Level } from "react-accessible-headings";
import { useDispatch, useSelector } from "react-redux";
import { g as getDefaultExportFromCjs } from "./lodash-CSqUlqk3.mjs";
import { g as getEnvironment, a as getBaseUrl, b as getParameterByName, c as getSubdomain } from "./utils-CO0rFpS6.mjs";
import { createSlice } from "@reduxjs/toolkit";
import { retryFunction } from "@missionlabs/smartagent-lib-shared/build/common/index.js";
import Button from "./Button.mjs";
import { f as forwardRef$1 } from "./index-B1_j71Th.mjs";
import AlertBanner from "./AlertBanner.mjs";
import Loader from "./Loader.mjs";
import { ClipLoader } from "react-spinners";
import Form from "./Form.mjs";
import forwardRef from "./Input.mjs";
const useDispatchTyped = () => useDispatch();
const Logo = "data:image/png;base64,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";
var axios$2 = { exports: {} };
var bind;
var hasRequiredBind;
function requireBind() {
  if (hasRequiredBind)
    return bind;
  hasRequiredBind = 1;
  bind = function bind2(fn, thisArg) {
    return function wrap() {
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }
      return fn.apply(thisArg, args);
    };
  };
  return bind;
}
var utils;
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils)
    return utils;
  hasRequiredUtils = 1;
  var bind2 = requireBind();
  var toString = Object.prototype.toString;
  function isArray(val) {
    return toString.call(val) === "[object Array]";
  }
  function isUndefined(val) {
    return typeof val === "undefined";
  }
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
  }
  function isArrayBuffer(val) {
    return toString.call(val) === "[object ArrayBuffer]";
  }
  function isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
  }
  function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    }
    return result;
  }
  function isString(val) {
    return typeof val === "string";
  }
  function isNumber(val) {
    return typeof val === "number";
  }
  function isObject(val) {
    return val !== null && typeof val === "object";
  }
  function isPlainObject(val) {
    if (toString.call(val) !== "[object Object]") {
      return false;
    }
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
  }
  function isDate(val) {
    return toString.call(val) === "[object Date]";
  }
  function isFile(val) {
    return toString.call(val) === "[object File]";
  }
  function isBlob(val) {
    return toString.call(val) === "[object Blob]";
  }
  function isFunction(val) {
    return toString.call(val) === "[object Function]";
  }
  function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
  }
  function isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
  }
  function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
  }
  function isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
      return false;
    }
    return typeof window !== "undefined" && typeof document !== "undefined";
  }
  function forEach(obj, fn) {
    if (obj === null || typeof obj === "undefined") {
      return;
    }
    if (typeof obj !== "object") {
      obj = [obj];
    }
    if (isArray(obj)) {
      for (var i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          fn.call(null, obj[key], key, obj);
        }
      }
    }
  }
  function merge() {
    var result = {};
    function assignValue(val, key) {
      if (isPlainObject(result[key]) && isPlainObject(val)) {
        result[key] = merge(result[key], val);
      } else if (isPlainObject(val)) {
        result[key] = merge({}, val);
      } else if (isArray(val)) {
        result[key] = val.slice();
      } else {
        result[key] = val;
      }
    }
    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }
    return result;
  }
  function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
      if (thisArg && typeof val === "function") {
        a[key] = bind2(val, thisArg);
      } else {
        a[key] = val;
      }
    });
    return a;
  }
  function stripBOM(content) {
    if (content.charCodeAt(0) === 65279) {
      content = content.slice(1);
    }
    return content;
  }
  utils = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isFunction,
    isStream,
    isURLSearchParams,
    isStandardBrowserEnv,
    forEach,
    merge,
    extend,
    trim,
    stripBOM
  };
  return utils;
}
var buildURL;
var hasRequiredBuildURL;
function requireBuildURL() {
  if (hasRequiredBuildURL)
    return buildURL;
  hasRequiredBuildURL = 1;
  var utils2 = requireUtils();
  function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  buildURL = function buildURL2(url, params, paramsSerializer) {
    if (!params) {
      return url;
    }
    var serializedParams;
    if (paramsSerializer) {
      serializedParams = paramsSerializer(params);
    } else if (utils2.isURLSearchParams(params)) {
      serializedParams = params.toString();
    } else {
      var parts = [];
      utils2.forEach(params, function serialize(val, key) {
        if (val === null || typeof val === "undefined") {
          return;
        }
        if (utils2.isArray(val)) {
          key = key + "[]";
        } else {
          val = [val];
        }
        utils2.forEach(val, function parseValue(v) {
          if (utils2.isDate(v)) {
            v = v.toISOString();
          } else if (utils2.isObject(v)) {
            v = JSON.stringify(v);
          }
          parts.push(encode(key) + "=" + encode(v));
        });
      });
      serializedParams = parts.join("&");
    }
    if (serializedParams) {
      var hashmarkIndex = url.indexOf("#");
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }
      url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
  };
  return buildURL;
}
var InterceptorManager_1;
var hasRequiredInterceptorManager;
function requireInterceptorManager() {
  if (hasRequiredInterceptorManager)
    return InterceptorManager_1;
  hasRequiredInterceptorManager = 1;
  var utils2 = requireUtils();
  function InterceptorManager() {
    this.handlers = [];
  }
  InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  };
  InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  };
  InterceptorManager.prototype.forEach = function forEach(fn) {
    utils2.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  };
  InterceptorManager_1 = InterceptorManager;
  return InterceptorManager_1;
}
var normalizeHeaderName;
var hasRequiredNormalizeHeaderName;
function requireNormalizeHeaderName() {
  if (hasRequiredNormalizeHeaderName)
    return normalizeHeaderName;
  hasRequiredNormalizeHeaderName = 1;
  var utils2 = requireUtils();
  normalizeHeaderName = function normalizeHeaderName2(headers, normalizedName) {
    utils2.forEach(headers, function processHeader(value, name) {
      if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
        headers[normalizedName] = value;
        delete headers[name];
      }
    });
  };
  return normalizeHeaderName;
}
var enhanceError;
var hasRequiredEnhanceError;
function requireEnhanceError() {
  if (hasRequiredEnhanceError)
    return enhanceError;
  hasRequiredEnhanceError = 1;
  enhanceError = function enhanceError2(error, config, code, request, response) {
    error.config = config;
    if (code) {
      error.code = code;
    }
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    };
    return error;
  };
  return enhanceError;
}
var createError;
var hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var enhanceError2 = requireEnhanceError();
  createError = function createError2(message, config, code, request, response) {
    var error = new Error(message);
    return enhanceError2(error, config, code, request, response);
  };
  return createError;
}
var settle;
var hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var createError2 = requireCreateError();
  settle = function settle2(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve(response);
    } else {
      reject(createError2(
        "Request failed with status code " + response.status,
        response.config,
        null,
        response.request,
        response
      ));
    }
  };
  return settle;
}
var cookies;
var hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var utils2 = requireUtils();
  cookies = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils2.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils2.isString(path)) {
            cookie.push("path=" + path);
          }
          if (utils2.isString(domain)) {
            cookie.push("domain=" + domain);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove() {
        }
      };
    }()
  );
  return cookies;
}
var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  if (hasRequiredIsAbsoluteURL)
    return isAbsoluteURL;
  hasRequiredIsAbsoluteURL = 1;
  isAbsoluteURL = function isAbsoluteURL2(url) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
  };
  return isAbsoluteURL;
}
var combineURLs;
var hasRequiredCombineURLs;
function requireCombineURLs() {
  if (hasRequiredCombineURLs)
    return combineURLs;
  hasRequiredCombineURLs = 1;
  combineURLs = function combineURLs2(baseURL2, relativeURL) {
    return relativeURL ? baseURL2.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL2;
  };
  return combineURLs;
}
var buildFullPath;
var hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var isAbsoluteURL2 = requireIsAbsoluteURL();
  var combineURLs2 = requireCombineURLs();
  buildFullPath = function buildFullPath2(baseURL2, requestedURL) {
    if (baseURL2 && !isAbsoluteURL2(requestedURL)) {
      return combineURLs2(baseURL2, requestedURL);
    }
    return requestedURL;
  };
  return buildFullPath;
}
var parseHeaders;
var hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var utils2 = requireUtils();
  var ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  parseHeaders = function parseHeaders2(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) {
      return parsed;
    }
    utils2.forEach(headers.split("\n"), function parser(line) {
      i = line.indexOf(":");
      key = utils2.trim(line.substr(0, i)).toLowerCase();
      val = utils2.trim(line.substr(i + 1));
      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }
        if (key === "set-cookie") {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
      }
    });
    return parsed;
  };
  return parseHeaders;
}
var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var utils2 = requireUtils();
  isURLSameOrigin = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;
      function resolveURL(url) {
        var href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin2(requestURL) {
        var parsed = utils2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function nonStandardBrowserEnv() {
      return function isURLSameOrigin2() {
        return true;
      };
    }()
  );
  return isURLSameOrigin;
}
var Cancel_1;
var hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function Cancel(message) {
    this.message = message;
  }
  Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  };
  Cancel.prototype.__CANCEL__ = true;
  Cancel_1 = Cancel;
  return Cancel_1;
}
var xhr;
var hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var utils2 = requireUtils();
  var settle2 = requireSettle();
  var cookies2 = requireCookies();
  var buildURL2 = requireBuildURL();
  var buildFullPath2 = requireBuildFullPath();
  var parseHeaders2 = requireParseHeaders();
  var isURLSameOrigin2 = requireIsURLSameOrigin();
  var createError2 = requireCreateError();
  var defaults = requireDefaults();
  var Cancel = requireCancel();
  xhr = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
      var requestData = config.data;
      var requestHeaders = config.headers;
      var responseType = config.responseType;
      var onCanceled;
      function done() {
        if (config.cancelToken) {
          config.cancelToken.unsubscribe(onCanceled);
        }
        if (config.signal) {
          config.signal.removeEventListener("abort", onCanceled);
        }
      }
      if (utils2.isFormData(requestData)) {
        delete requestHeaders["Content-Type"];
      }
      var request = new XMLHttpRequest();
      if (config.auth) {
        var username = config.auth.username || "";
        var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
        requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
      }
      var fullPath = buildFullPath2(config.baseURL, config.url);
      request.open(config.method.toUpperCase(), buildURL2(fullPath, config.params, config.paramsSerializer), true);
      request.timeout = config.timeout;
      function onloadend() {
        if (!request) {
          return;
        }
        var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders2(request.getAllResponseHeaders()) : null;
        var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
        var response = {
          data: responseData,
          status: request.status,
          statusText: request.statusText,
          headers: responseHeaders,
          config,
          request
        };
        settle2(function _resolve(value) {
          resolve(value);
          done();
        }, function _reject(err) {
          reject(err);
          done();
        }, response);
        request = null;
      }
      if ("onloadend" in request) {
        request.onloadend = onloadend;
      } else {
        request.onreadystatechange = function handleLoad() {
          if (!request || request.readyState !== 4) {
            return;
          }
          if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request.onabort = function handleAbort() {
        if (!request) {
          return;
        }
        reject(createError2("Request aborted", config, "ECONNABORTED", request));
        request = null;
      };
      request.onerror = function handleError() {
        reject(createError2("Network Error", config, null, request));
        request = null;
      };
      request.ontimeout = function handleTimeout() {
        var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
        var transitional = config.transitional || defaults.transitional;
        if (config.timeoutErrorMessage) {
          timeoutErrorMessage = config.timeoutErrorMessage;
        }
        reject(createError2(
          timeoutErrorMessage,
          config,
          transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          request
        ));
        request = null;
      };
      if (utils2.isStandardBrowserEnv()) {
        var xsrfValue = (config.withCredentials || isURLSameOrigin2(fullPath)) && config.xsrfCookieName ? cookies2.read(config.xsrfCookieName) : void 0;
        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }
      if ("setRequestHeader" in request) {
        utils2.forEach(requestHeaders, function setRequestHeader(val, key) {
          if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
            delete requestHeaders[key];
          } else {
            request.setRequestHeader(key, val);
          }
        });
      }
      if (!utils2.isUndefined(config.withCredentials)) {
        request.withCredentials = !!config.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request.responseType = config.responseType;
      }
      if (typeof config.onDownloadProgress === "function") {
        request.addEventListener("progress", config.onDownloadProgress);
      }
      if (typeof config.onUploadProgress === "function" && request.upload) {
        request.upload.addEventListener("progress", config.onUploadProgress);
      }
      if (config.cancelToken || config.signal) {
        onCanceled = function(cancel) {
          if (!request) {
            return;
          }
          reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
          request.abort();
          request = null;
        };
        config.cancelToken && config.cancelToken.subscribe(onCanceled);
        if (config.signal) {
          config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
      }
      if (!requestData) {
        requestData = null;
      }
      request.send(requestData);
    });
  };
  return xhr;
}
var defaults_1;
var hasRequiredDefaults;
function requireDefaults() {
  if (hasRequiredDefaults)
    return defaults_1;
  hasRequiredDefaults = 1;
  var utils2 = requireUtils();
  var normalizeHeaderName2 = requireNormalizeHeaderName();
  var enhanceError2 = requireEnhanceError();
  var DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function setContentTypeIfUnset(headers, value) {
    if (!utils2.isUndefined(headers) && utils2.isUndefined(headers["Content-Type"])) {
      headers["Content-Type"] = value;
    }
  }
  function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") {
      adapter = requireXhr();
    } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
      adapter = requireXhr();
    }
    return adapter;
  }
  function stringifySafely(rawValue, parser, encoder) {
    if (utils2.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils2.trim(rawValue);
      } catch (e) {
        if (e.name !== "SyntaxError") {
          throw e;
        }
      }
    }
    return (0, JSON.stringify)(rawValue);
  }
  var defaults = {
    transitional: {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false
    },
    adapter: getDefaultAdapter(),
    transformRequest: [function transformRequest(data2, headers) {
      normalizeHeaderName2(headers, "Accept");
      normalizeHeaderName2(headers, "Content-Type");
      if (utils2.isFormData(data2) || utils2.isArrayBuffer(data2) || utils2.isBuffer(data2) || utils2.isStream(data2) || utils2.isFile(data2) || utils2.isBlob(data2)) {
        return data2;
      }
      if (utils2.isArrayBufferView(data2)) {
        return data2.buffer;
      }
      if (utils2.isURLSearchParams(data2)) {
        setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
        return data2.toString();
      }
      if (utils2.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
        setContentTypeIfUnset(headers, "application/json");
        return stringifySafely(data2);
      }
      return data2;
    }],
    transformResponse: [function transformResponse(data2) {
      var transitional = this.transitional || defaults.transitional;
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
      var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
      if (strictJSONParsing || forcedJSONParsing && utils2.isString(data2) && data2.length) {
        try {
          return JSON.parse(data2);
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === "SyntaxError") {
              throw enhanceError2(e, this, "E_JSON_PARSE");
            }
            throw e;
          }
        }
      }
      return data2;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },
    headers: {
      common: {
        "Accept": "application/json, text/plain, */*"
      }
    }
  };
  utils2.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
    defaults.headers[method] = {};
  });
  utils2.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
    defaults.headers[method] = utils2.merge(DEFAULT_CONTENT_TYPE);
  });
  defaults_1 = defaults;
  return defaults_1;
}
var transformData;
var hasRequiredTransformData;
function requireTransformData() {
  if (hasRequiredTransformData)
    return transformData;
  hasRequiredTransformData = 1;
  var utils2 = requireUtils();
  var defaults = requireDefaults();
  transformData = function transformData2(data2, headers, fns) {
    var context = this || defaults;
    utils2.forEach(fns, function transform(fn) {
      data2 = fn.call(context, data2, headers);
    });
    return data2;
  };
  return transformData;
}
var isCancel;
var hasRequiredIsCancel;
function requireIsCancel() {
  if (hasRequiredIsCancel)
    return isCancel;
  hasRequiredIsCancel = 1;
  isCancel = function isCancel2(value) {
    return !!(value && value.__CANCEL__);
  };
  return isCancel;
}
var dispatchRequest;
var hasRequiredDispatchRequest;
function requireDispatchRequest() {
  if (hasRequiredDispatchRequest)
    return dispatchRequest;
  hasRequiredDispatchRequest = 1;
  var utils2 = requireUtils();
  var transformData2 = requireTransformData();
  var isCancel2 = requireIsCancel();
  var defaults = requireDefaults();
  var Cancel = requireCancel();
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
    if (config.signal && config.signal.aborted) {
      throw new Cancel("canceled");
    }
  }
  dispatchRequest = function dispatchRequest2(config) {
    throwIfCancellationRequested(config);
    config.headers = config.headers || {};
    config.data = transformData2.call(
      config,
      config.data,
      config.headers,
      config.transformRequest
    );
    config.headers = utils2.merge(
      config.headers.common || {},
      config.headers[config.method] || {},
      config.headers
    );
    utils2.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      function cleanHeaderConfig(method) {
        delete config.headers[method];
      }
    );
    var adapter = config.adapter || defaults.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config);
      response.data = transformData2.call(
        config,
        response.data,
        response.headers,
        config.transformResponse
      );
      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel2(reason)) {
        throwIfCancellationRequested(config);
        if (reason && reason.response) {
          reason.response.data = transformData2.call(
            config,
            reason.response.data,
            reason.response.headers,
            config.transformResponse
          );
        }
      }
      return Promise.reject(reason);
    });
  };
  return dispatchRequest;
}
var mergeConfig;
var hasRequiredMergeConfig;
function requireMergeConfig() {
  if (hasRequiredMergeConfig)
    return mergeConfig;
  hasRequiredMergeConfig = 1;
  var utils2 = requireUtils();
  mergeConfig = function mergeConfig2(config1, config2) {
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
      if (utils2.isPlainObject(target) && utils2.isPlainObject(source)) {
        return utils2.merge(target, source);
      } else if (utils2.isPlainObject(source)) {
        return utils2.merge({}, source);
      } else if (utils2.isArray(source)) {
        return source.slice();
      }
      return source;
    }
    function mergeDeepProperties(prop) {
      if (!utils2.isUndefined(config2[prop])) {
        return getMergedValue(config1[prop], config2[prop]);
      } else if (!utils2.isUndefined(config1[prop])) {
        return getMergedValue(void 0, config1[prop]);
      }
    }
    function valueFromConfig2(prop) {
      if (!utils2.isUndefined(config2[prop])) {
        return getMergedValue(void 0, config2[prop]);
      }
    }
    function defaultToConfig2(prop) {
      if (!utils2.isUndefined(config2[prop])) {
        return getMergedValue(void 0, config2[prop]);
      } else if (!utils2.isUndefined(config1[prop])) {
        return getMergedValue(void 0, config1[prop]);
      }
    }
    function mergeDirectKeys(prop) {
      if (prop in config2) {
        return getMergedValue(config1[prop], config2[prop]);
      } else if (prop in config1) {
        return getMergedValue(void 0, config1[prop]);
      }
    }
    var mergeMap = {
      "url": valueFromConfig2,
      "method": valueFromConfig2,
      "data": valueFromConfig2,
      "baseURL": defaultToConfig2,
      "transformRequest": defaultToConfig2,
      "transformResponse": defaultToConfig2,
      "paramsSerializer": defaultToConfig2,
      "timeout": defaultToConfig2,
      "timeoutMessage": defaultToConfig2,
      "withCredentials": defaultToConfig2,
      "adapter": defaultToConfig2,
      "responseType": defaultToConfig2,
      "xsrfCookieName": defaultToConfig2,
      "xsrfHeaderName": defaultToConfig2,
      "onUploadProgress": defaultToConfig2,
      "onDownloadProgress": defaultToConfig2,
      "decompress": defaultToConfig2,
      "maxContentLength": defaultToConfig2,
      "maxBodyLength": defaultToConfig2,
      "transport": defaultToConfig2,
      "httpAgent": defaultToConfig2,
      "httpsAgent": defaultToConfig2,
      "cancelToken": defaultToConfig2,
      "socketPath": defaultToConfig2,
      "responseEncoding": defaultToConfig2,
      "validateStatus": mergeDirectKeys
    };
    utils2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
      var merge = mergeMap[prop] || mergeDeepProperties;
      var configValue = merge(prop);
      utils2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
  };
  return mergeConfig;
}
var data;
var hasRequiredData;
function requireData() {
  if (hasRequiredData)
    return data;
  hasRequiredData = 1;
  data = {
    "version": "0.24.0"
  };
  return data;
}
var validator;
var hasRequiredValidator;
function requireValidator() {
  if (hasRequiredValidator)
    return validator;
  hasRequiredValidator = 1;
  var VERSION = requireData().version;
  var validators = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
    validators[type] = function validator2(thing) {
      return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
  });
  var deprecatedWarnings = {};
  validators.transitional = function transitional(validator2, version, message) {
    function formatMessage(opt, desc) {
      return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    return function(value, opt, opts) {
      if (validator2 === false) {
        throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
      }
      if (version && !deprecatedWarnings[opt]) {
        deprecatedWarnings[opt] = true;
        console.warn(
          formatMessage(
            opt,
            " has been deprecated since v" + version + " and will be removed in the near future"
          )
        );
      }
      return validator2 ? validator2(value, opt, opts) : true;
    };
  };
  function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") {
      throw new TypeError("options must be an object");
    }
    var keys = Object.keys(options);
    var i = keys.length;
    while (i-- > 0) {
      var opt = keys[i];
      var validator2 = schema[opt];
      if (validator2) {
        var value = options[opt];
        var result = value === void 0 || validator2(value, opt, options);
        if (result !== true) {
          throw new TypeError("option " + opt + " must be " + result);
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw Error("Unknown option " + opt);
      }
    }
  }
  validator = {
    assertOptions,
    validators
  };
  return validator;
}
var Axios_1;
var hasRequiredAxios$2;
function requireAxios$2() {
  if (hasRequiredAxios$2)
    return Axios_1;
  hasRequiredAxios$2 = 1;
  var utils2 = requireUtils();
  var buildURL2 = requireBuildURL();
  var InterceptorManager = requireInterceptorManager();
  var dispatchRequest2 = requireDispatchRequest();
  var mergeConfig2 = requireMergeConfig();
  var validator2 = requireValidator();
  var validators = validator2.validators;
  function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  Axios.prototype.request = function request(config) {
    if (typeof config === "string") {
      config = arguments[1] || {};
      config.url = arguments[0];
    } else {
      config = config || {};
    }
    config = mergeConfig2(this.defaults, config);
    if (config.method) {
      config.method = config.method.toLowerCase();
    } else if (this.defaults.method) {
      config.method = this.defaults.method.toLowerCase();
    } else {
      config.method = "get";
    }
    var transitional = config.transitional;
    if (transitional !== void 0) {
      validator2.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
      var chain = [dispatchRequest2, void 0];
      Array.prototype.unshift.apply(chain, requestInterceptorChain);
      chain = chain.concat(responseInterceptorChain);
      promise = Promise.resolve(config);
      while (chain.length) {
        promise = promise.then(chain.shift(), chain.shift());
      }
      return promise;
    }
    var newConfig = config;
    while (requestInterceptorChain.length) {
      var onFulfilled = requestInterceptorChain.shift();
      var onRejected = requestInterceptorChain.shift();
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected(error);
        break;
      }
    }
    try {
      promise = dispatchRequest2(newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    while (responseInterceptorChain.length) {
      promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    }
    return promise;
  };
  Axios.prototype.getUri = function getUri(config) {
    config = mergeConfig2(this.defaults, config);
    return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
  };
  utils2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
    Axios.prototype[method] = function(url, config) {
      return this.request(mergeConfig2(config || {}, {
        method,
        url,
        data: (config || {}).data
      }));
    };
  });
  utils2.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
    Axios.prototype[method] = function(url, data2, config) {
      return this.request(mergeConfig2(config || {}, {
        method,
        url,
        data: data2
      }));
    };
  });
  Axios_1 = Axios;
  return Axios_1;
}
var CancelToken_1;
var hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var Cancel = requireCancel();
  function CancelToken(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    var token = this;
    this.promise.then(function(cancel) {
      if (!token._listeners)
        return;
      var i;
      var l = token._listeners.length;
      for (i = 0; i < l; i++) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = function(onfulfilled) {
      var _resolve;
      var promise = new Promise(function(resolve) {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message) {
      if (token.reason) {
        return;
      }
      token.reason = new Cancel(message);
      resolvePromise(token.reason);
    });
  }
  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };
  CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  };
  CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    var index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  };
  CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  };
  CancelToken_1 = CancelToken;
  return CancelToken_1;
}
var spread;
var hasRequiredSpread;
function requireSpread() {
  if (hasRequiredSpread)
    return spread;
  hasRequiredSpread = 1;
  spread = function spread2(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };
  return spread;
}
var isAxiosError;
var hasRequiredIsAxiosError;
function requireIsAxiosError() {
  if (hasRequiredIsAxiosError)
    return isAxiosError;
  hasRequiredIsAxiosError = 1;
  isAxiosError = function isAxiosError2(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
  };
  return isAxiosError;
}
var hasRequiredAxios$1;
function requireAxios$1() {
  if (hasRequiredAxios$1)
    return axios$2.exports;
  hasRequiredAxios$1 = 1;
  var utils2 = requireUtils();
  var bind2 = requireBind();
  var Axios = requireAxios$2();
  var mergeConfig2 = requireMergeConfig();
  var defaults = requireDefaults();
  function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind2(Axios.prototype.request, context);
    utils2.extend(instance, Axios.prototype, context);
    utils2.extend(instance, context);
    instance.create = function create(instanceConfig) {
      return createInstance(mergeConfig2(defaultConfig, instanceConfig));
    };
    return instance;
  }
  var axios2 = createInstance(defaults);
  axios2.Axios = Axios;
  axios2.Cancel = requireCancel();
  axios2.CancelToken = requireCancelToken();
  axios2.isCancel = requireIsCancel();
  axios2.VERSION = requireData().version;
  axios2.all = function all(promises) {
    return Promise.all(promises);
  };
  axios2.spread = requireSpread();
  axios2.isAxiosError = requireIsAxiosError();
  axios$2.exports = axios2;
  axios$2.exports.default = axios2;
  return axios$2.exports;
}
var axios$1;
var hasRequiredAxios;
function requireAxios() {
  if (hasRequiredAxios)
    return axios$1;
  hasRequiredAxios = 1;
  axios$1 = requireAxios$1();
  return axios$1;
}
var axiosExports = requireAxios();
const axios = /* @__PURE__ */ getDefaultExportFromCjs(axiosExports);
const env = getEnvironment();
const baseURL = getBaseUrl(env);
function makeRequest({
  url,
  method = "get",
  data: data2,
  headers,
  params,
  signal,
  base,
  ignoreToken = false
}) {
  if (process.env.NODE_ENV === "test") {
    const testName = typeof expect !== "undefined" ? expect == null ? void 0 : expect.getState().testPath : void 0;
    console.warn(
      `A request was made in the tests to ${method.toUpperCase()} ${url} in test: ${testName}`
    );
  }
  const serviceRegion = localStorage.getItem("serviceRegion");
  const serviceRegionURL = serviceRegion ? serviceRegion + "." : "";
  const serviceURL = base ?? "https://" + serviceRegionURL + baseURL;
  return axios({
    baseURL: serviceURL,
    url,
    method,
    data: data2,
    headers,
    params,
    signal,
    ignoreToken
  });
}
async function getLoginConfig(companyID) {
  const response = await makeRequest({
    url: `/company-service/companies/${companyID}/login-config`
  });
  return response.data;
}
const defaultState = {
  error: false,
  message: "",
  loading: false,
  ID: "",
  appConfig: {
    afterCallWorkInitialTimeoutSeconds: 20,
    chatAfterCallWorkInitialTimeoutSeconds: 60,
    defaultNumberDPAPassesRequiredForPass: 2
  },
  instances: [],
  instance: void 0,
  identityManagement: void 0,
  features: [],
  callProviderInitStartTime: void 0
};
const appSlice = createSlice({
  name: "app",
  initialState: defaultState,
  reducers: {
    initAppLoading(state) {
      state.loading = true;
    },
    // Dispatched by initApp on initial (pre-login) load, so middleware that needs to run
    // before login (ad, cognito) can key off it instead of the full initAppSuccess payload.
    preLoginInitAppSuccess(state, action) {
      return {
        ...state,
        ...action.payload,
        // login-config only returns a reduced subset of appConfig - keep the rest of the
        // existing defaults/values
        appConfig: { ...state.appConfig, ...action.payload.appConfig },
        error: false,
        loading: false
      };
    },
    appError(state, action) {
      state.message = action.payload || "";
      state.error = true;
    },
    selectInstance(state, action) {
      state.appConfig = action.payload.appConfig;
      state.instance = action.payload.instance;
    },
    setCallProviderInitStartTime(state, action) {
      state.callProviderInitStartTime = action.payload;
    },
    clearInstance(state) {
      state.instance = void 0;
    },
    ccpLogout() {
    }
  }
});
const {
  appError,
  ccpLogout,
  clearInstance,
  initAppLoading,
  preLoginInitAppSuccess,
  selectInstance: selectInstance$1,
  setCallProviderInitStartTime
} = appSlice.actions;
const appReducer = appSlice.reducer;
function initApp() {
  return async (dispatch, getState) => {
    var _a;
    const companyID = (_a = getParameterByName("companyID") || getSubdomain()) == null ? void 0 : _a.replace(
      /[^a-zA-Z0-9-_]/g,
      ""
    );
    if (!companyID) {
      return dispatch(appError());
    }
    dispatch(initAppLoading());
    try {
      const company = await getLoginConfig(companyID);
      const identityManagement = getParameterByName("identityManagement");
      if (identityManagement)
        company.identityManagement = identityManagement;
      dispatch(preLoginInitAppSuccess(company));
      const instanceKey = getParameterByName("instanceKey");
      const instances = company.instances;
      const isAuthed = !!getState().auth.refreshToken;
      const instance = instances.length === 1 ? instances[0] : instanceKey ? instances.find((inst) => inst.key === instanceKey) : isAuthed ? getState().app.instance : null;
      if (!instance) {
        return dispatch(clearInstance());
      }
      return dispatch(selectInstance(instance, getState().app.appConfig));
    } catch (err) {
      console.warn(err);
      return dispatch(appError());
    }
  };
}
function selectInstance(instance, appConfig) {
  return selectInstance$1({ instance, appConfig });
}
async function refreshToken$1(companyID, username, refreshToken2, instanceID) {
  return await makeRequest({
    url: `/auth-service/companies/${companyID}/tokens/refresh`,
    method: "post",
    data: {
      username,
      refreshTokenID: refreshToken2,
      instanceID
    }
  });
}
function logout$2(companyID, token, username, instanceID) {
  makeRequest({
    url: `/auth-service/companies/${companyID}/tokens/${token}`,
    method: "delete",
    data: {
      username,
      instanceID
    }
  });
}
async function authenticateUser$1(companyID, token, instanceID, username, tokenInBody = false, identityManagement) {
  if (tokenInBody)
    return await makeRequest({
      url: `/auth-service/companies/${companyID}/tokens`,
      method: "put",
      data: {
        username,
        instanceID,
        tokenID: token,
        identityManagement
      }
    });
  else
    return await makeRequest({
      url: `/auth-service/companies/${companyID}/tokens/${token}`,
      method: "put",
      data: {
        username,
        instanceID
      }
    });
}
async function requestToken$1(companyID, username, instanceID) {
  return await makeRequest({
    url: `/auth-service/companies/${companyID}/tokens`,
    method: "post",
    data: {
      username,
      instanceID
    }
  });
}
const initialState$1 = {
  redirect: null
};
const globalSlice = createSlice({
  name: "global",
  initialState: initialState$1,
  reducers: {
    doRedirect(state, action) {
      return { ...state, redirect: action.payload };
    },
    clearRedirect(state) {
      return { ...state, redirect: null };
    }
  }
});
const {
  doRedirect,
  clearRedirect
} = globalSlice.actions;
const globalReducer = globalSlice.reducer;
function setRedirect(to, state) {
  return doRedirect({ to, state });
}
const initialState = null;
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userLoaded(state, action) {
      return { ...state, ...action.payload };
    },
    userError(state) {
      return { ...state, error: true };
    },
    userAuthenticated(state, action) {
      if (!state)
        return state;
      console.log("authenticated");
      return { ...state, agentID: action.payload.agentID };
    },
    authenticatingUser() {
    },
    validatingToken() {
    },
    requestingToken() {
    },
    tokenRequested() {
    },
    tokenError() {
    },
    authExternalUserRequest(_state, _action) {
    },
    userAuthError(_state, _action) {
    },
    submitMFA(_state, _action) {
    },
    mfaRequired(_state, _action) {
    },
    login(_state, _action) {
    },
    logout() {
      return null;
    }
  }
});
const {
  userLoaded: userLoaded$1,
  login: login$1,
  tokenError: tokenError$1,
  requestingToken,
  tokenRequested,
  validatingToken,
  userError: userError$1,
  authenticatingUser,
  userAuthError,
  userAuthenticated: userAuthenticated$1,
  authExternalUserRequest,
  mfaRequired: mfaRequired$1,
  submitMFA: submitMFA$1,
  logout: logout$1
} = userSlice.actions;
const userReducer = userSlice.reducer;
const UserActions = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  authExternalUserRequest,
  authenticatingUser,
  default: userReducer,
  login: login$1,
  logout: logout$1,
  mfaRequired: mfaRequired$1,
  requestingToken,
  submitMFA: submitMFA$1,
  tokenError: tokenError$1,
  tokenRequested,
  userAuthError,
  userAuthenticated: userAuthenticated$1,
  userError: userError$1,
  userLoaded: userLoaded$1,
  userSlice,
  validatingToken
}, Symbol.toStringTag, { value: "Module" }));
const {
  userLoaded,
  mfaRequired,
  tokenError,
  submitMFA,
  userError,
  userAuthenticated,
  login
} = UserActions;
function logout() {
  return (dispatch, getState) => {
    const companyID = getState().app.ID;
    const token = getState().auth.token;
    const user = getState().user;
    const instanceID = getState().app.instance.ID;
    if (!token || !user) {
      return dispatch(logout$1());
    }
    logout$2(companyID, token, user.username, instanceID);
    return dispatch(logout$1());
  };
}
function authError(error) {
  return userAuthError({ error: error || "There was an error" });
}
function authenticateExternalUser(credentials) {
  return async (dispatch, getState) => {
    dispatch(
      authExternalUserRequest({
        credentials,
        ccpURL: getState().app.instance.ccpURL
      })
    );
  };
}
function authenticateUser(token, tokenInBody = false) {
  return async (dispatch, getState) => {
    var _a, _b, _c, _d, _e, _f;
    dispatch(authenticatingUser());
    const { app, user, auth } = getState();
    if (!app.instance) {
      if (((_a = app.instances) == null ? void 0 : _a.length) !== 1) {
        console.log(
          "Unable to log user back in - multiple instances for client and instance not selected yet"
        );
        return dispatch(authError(`Session expired, please login`));
      }
    }
    const companyID = app.ID;
    const username = user ? user.username : void 0;
    const instanceID = ((_b = app.instance) == null ? void 0 : _b.ID) || app.instances[0].ID;
    try {
      const res = await retryFunction({
        retryCount: 1e5,
        waitTimeMs: app.appConfig.loginRequestRetryWaitTime ?? 5e3,
        errorConditionToRetry: (error) => {
          return error.code === "429";
        }
      })(
        async () => await authenticateUser$1(
          companyID,
          token,
          instanceID,
          username,
          tokenInBody,
          getParameterByName("identityManagement") || void 0
        )
      );
      const refreshToken2 = res.headers["x-refresh-token"];
      const authToken = res.data;
      if (authToken.credentials) {
        dispatch(authenticateExternalUser(authToken.credentials));
      }
      if (!auth.refreshToken) {
        dispatch(setRedirect("/"));
      }
      dispatch(
        userAuthenticated({
          token: authToken.ID,
          refreshToken: refreshToken2,
          features: authToken.features,
          agentID: authToken.userID,
          roles: authToken.securityRoles
        })
      );
      if (app.instance) {
        dispatch(selectInstance(app.instance, app.appConfig));
      }
      return;
    } catch (e) {
      console.warn(e);
      const ex = e;
      if (ex.response && ex.response.status === 404) {
        return dispatch(authError(`User does not exist in connect`));
      } else {
        const errorMessage = ((_d = (_c = ex == null ? void 0 : ex.response) == null ? void 0 : _c.data) == null ? void 0 : _d.error) || ((_f = (_e = ex == null ? void 0 : ex.response) == null ? void 0 : _e.data) == null ? void 0 : _f.message) || "";
        return dispatch(authError(errorMessage));
      }
    }
  };
}
function refreshToken() {
  return async (dispatch, getState) => {
    var _a;
    dispatch(validatingToken());
    const companyID = getState().app.ID;
    const username = getState().user.username;
    const refreshToken2 = getState().auth.refreshToken;
    const instanceID = getState().app.instance.ID || null;
    try {
      const res = await refreshToken$1(companyID, username, refreshToken2, instanceID);
      const XRefreshToken = res.headers["x-refresh-token"];
      const authToken = res.data;
      return dispatch(
        userAuthenticated({
          token: authToken.ID,
          refreshToken: XRefreshToken,
          features: authToken.features,
          agentID: authToken.userID,
          roles: authToken.securityRoles
        })
      );
    } catch (err) {
      const { authenticated } = getState().auth;
      const e = err;
      console.log("error on refresh", err);
      if (((_a = e.response) == null ? void 0 : _a.status) === 401) {
        if (authenticated) {
          return dispatch(logout());
        } else {
          return dispatch(requestToken());
        }
      }
    }
  };
}
function requestToken() {
  return async (dispatch, getState) => {
    dispatch(requestingToken());
    const companyID = getState().app.ID;
    const username = getState().user.username;
    const instanceID = getState().app.instance.ID;
    try {
      await requestToken$1(companyID, username, instanceID);
      dispatch(tokenRequested());
    } catch (ex) {
      dispatch(tokenError$1());
    }
  };
}
const user_actions = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  authError,
  authenticateExternalUser,
  authenticateUser,
  login,
  logout,
  mfaRequired,
  refreshToken,
  requestToken,
  submitMFA,
  tokenError,
  userAuthenticated,
  userError,
  userLoaded
}, Symbol.toStringTag, { value: "Module" }));
const LoginSplash = ({ loading, onClick }) => {
  return /* @__PURE__ */ jsxs("div", { className: "row column auto", children: [
    /* @__PURE__ */ jsx("p", { children: "Let's get started" }),
    /* @__PURE__ */ jsx(
      Button,
      {
        autoFocus: true,
        className: "md-mar-top",
        round: true,
        large: true,
        onClick,
        styling: "primary",
        children: loading ? /* @__PURE__ */ jsx(ClipLoader, { color: "#fff", size: 20 }) : "Login"
      }
    )
  ] });
};
const LoginExternal = () => {
  const dispatch = useDispatchTyped();
  const auth = useSelector((state) => state.auth);
  const app = useSelector((state) => state.app);
  const [showLoginInfoBanner, setShowLoginInfoBanner] = useState(false);
  useEffect(() => {
    let timerId;
    if (!auth.logout) {
      timerId = setTimeout(() => dispatch(login()), 1e3);
    }
    return () => {
      timerId && clearTimeout(timerId);
    };
  }, []);
  useEffect(() => {
    let timerId;
    if (auth.authenticating) {
      timerId = setTimeout(() => {
        setShowLoginInfoBanner(true);
      }, 7e3);
    }
    return () => {
      timerId && clearTimeout(timerId);
    };
  }, [auth.authenticating]);
  const onRetry = () => {
    window.location.reload();
  };
  return /* @__PURE__ */ jsx(Fragment, { children: auth.authenticating || auth.authenticated ? /* @__PURE__ */ jsx("div", { className: "row column row middle", children: /* @__PURE__ */ jsxs("div", { className: "sa-login-text", "aria-live": "polite", children: [
    showLoginInfoBanner && /* @__PURE__ */ jsx(AlertBanner, { type: "info", children: app.appConfig.loginInfoBannerText ? app.appConfig.loginInfoBannerText : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("p", { children: "During peak times, authentication may take up to 1 minute - this screen will automatically refresh." }),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx("p", { children: "If you are still seeing this message after 2 minutes, please refresh your page." })
    ] }) }),
    auth.authenticating || auth.authenticated ? /* @__PURE__ */ jsxs("div", { className: "sa-login-text-loader-wrapper", children: [
      /* @__PURE__ */ jsx(Loader, { loaderType: "clip", className: "sa-login-text-loader" }),
      /* @__PURE__ */ jsx("p", { children: "Authentication in progress..." })
    ] }) : "You're using external log in, please wait"
  ] }) }) : auth.authError ? /* @__PURE__ */ jsxs("div", { className: "row column row middle", "aria-live": "polite", children: [
    /* @__PURE__ */ jsx("div", { className: "sa-login-text sa-login-error", children: auth.authError }),
    /* @__PURE__ */ jsx(Button, { styling: "primary", large: true, round: true, onClick: onRetry, children: "Retry" })
  ] }) : /* @__PURE__ */ jsx(LoginSplash, { onClick: () => dispatch(login()), loading: !auth.logout }) });
};
const InfoErrorIcon = "data:image/svg+xml,%3csvg%20width='14'%20height='14'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cpath%20d='M7%20.583a6.417%206.417%200%20110%2012.834A6.417%206.417%200%20017%20.583zm0%20.755a5.662%205.662%200%20100%2011.324A5.662%205.662%200%20007%201.338zm.802%204.86v4.01H6.198v-4.01h1.604zM7%203.792a.802.802%200%20110%201.604.802.802%200%20010-1.604z'%20id='a'/%3e%3c/defs%3e%3cuse%20fill='%23ff6161'%20xlink:href='%23a'/%3e%3c/svg%3e";
const LoginToken = () => {
  const dispatch = useDispatchTyped();
  const { authError: authError2, authenticating, validatingToken: validatingToken2, tokenError: tokenError2, tokenRequested: tokenRequested2, logout: logout2 } = useSelector((state) => state.auth);
  const appError2 = useSelector((state) => state.app.error);
  const [token, setToken] = useState("");
  useEffect(() => {
    if (!logout2)
      setTimeout(() => dispatch(login()), 1e3);
  }, [logout2, login]);
  const onTokenChange = (newToken) => {
    setToken(newToken);
  };
  const onAuth = async () => {
    dispatch(authenticateUser(token, true));
  };
  const onRetry = () => {
    window.location.href = window.location.href;
  };
  return /* @__PURE__ */ jsx(Fragment, { children: appError2 ? /* @__PURE__ */ jsxs("div", { className: "row column", "aria-live": "polite", children: [
    /* @__PURE__ */ jsx("div", { className: "sa-login-text sa-login-error", children: "There was a problem logging you in, please try again" }),
    /* @__PURE__ */ jsx(
      Button,
      {
        className: "sa-login-button",
        onClick: onRetry,
        round: true,
        large: true,
        styling: "primary",
        children: "Retry"
      }
    )
  ] }) : tokenRequested2 || tokenError2 || authError2 || validatingToken2 || authenticating ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Form, { onSubmit: onAuth, className: "sa-login-form", children: validatingToken2 && !token ? /* @__PURE__ */ jsxs("div", { className: "row middle center column", children: [
    /* @__PURE__ */ jsx("p", { children: "Validating Token" }),
    /* @__PURE__ */ jsx(
      Button,
      {
        className: "sa-login-button md-mar-top",
        disabled: !token,
        round: true,
        large: true,
        styling: "primary",
        children: /* @__PURE__ */ jsx(ClipLoader, { color: "#fff", size: 20 })
      }
    )
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "row between middle", children: [
      /* @__PURE__ */ jsx(H, { className: "title", children: "Enter Code" }),
      (tokenError2 || authError2) && /* @__PURE__ */ jsxs("div", { className: "sa-login-error", "aria-live": "polite", children: [
        /* @__PURE__ */ jsx("img", { alt: "Error", src: InfoErrorIcon }),
        /* @__PURE__ */ jsx("p", { children: "There was a problem with the token." })
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "sa-login-text", children: /* @__PURE__ */ jsx("p", { children: "Your authorisation code has been sent to your email." }) }),
    /* @__PURE__ */ jsx(
      forwardRef,
      {
        autoFocus: true,
        required: true,
        label: "Enter Code",
        value: token,
        onChange: onTokenChange,
        showError: true
      }
    ),
    /* @__PURE__ */ jsx("a", { className: "request-code", href: window.location.href, children: "Not got your code? Click to request a new one" }),
    /* @__PURE__ */ jsx(
      Button,
      {
        className: "sa-login-button md-mar-top",
        disabled: !token,
        round: true,
        large: true,
        styling: "primary",
        children: validatingToken2 || authenticating ? /* @__PURE__ */ jsx(ClipLoader, { color: "#fff", size: 20 }) : "Submit"
      }
    )
  ] }) }) }) : /* @__PURE__ */ jsx(LoginSplash, { onClick: login, loading: !logout2 }) });
};
const MFARequired = () => {
  const dispatch = useDispatchTyped();
  const { authError: authError2, authenticating, mfa } = useSelector((state) => state.auth);
  const [code, setCode] = useState("");
  const onSubmit = () => {
    dispatch(submitMFA(code));
  };
  return /* @__PURE__ */ jsxs(Form, { onSubmit, className: "sa-login-form", children: [
    /* @__PURE__ */ jsxs("div", { className: "row between middle", children: [
      /* @__PURE__ */ jsx(H, { className: "title", children: "Authentication Code" }),
      authError2 && /* @__PURE__ */ jsxs("div", { className: "sa-login-error", "aria-live": "polite", children: [
        /* @__PURE__ */ jsx("img", { alt: "Error", src: InfoErrorIcon }),
        authError2
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "sa-login-text", children: [
      "Please enter the code sent to the",
      " ",
      (mfa == null ? void 0 : mfa.type) === "SMS" ? "phone number" : "email address",
      " ",
      mfa == null ? void 0 : mfa.destination
    ] }),
    /* @__PURE__ */ jsx(
      forwardRef,
      {
        className: "md-mar-bottom",
        onChange: (code2) => setCode(code2),
        value: code,
        required: true,
        type: "text",
        label: "Authentication Code"
      }
    ),
    /* @__PURE__ */ jsx(Button, { round: true, large: true, styling: "primary", children: authenticating ? /* @__PURE__ */ jsx(ClipLoader, { color: "#fff", size: 20 }) : "Login" })
  ] });
};
const LoginUsernamePassword = () => {
  const dispatch = useDispatchTyped();
  const { authError: authError2, authenticating, authenticated, mfa } = useSelector(
    (state) => state.auth
  );
  const appError2 = useSelector((state) => state.app.error);
  const [formState, setFormState] = useState({
    user: "",
    pass: "",
    splash: true
  });
  const onAuth = () => {
    const { user, pass } = formState;
    if (user && pass) {
      dispatch(login({ username: user, password: pass }));
    }
  };
  const onRetry = () => {
    window.location.href = window.location.href;
  };
  return /* @__PURE__ */ jsx(Fragment, { children: formState.splash ? /* @__PURE__ */ jsx(
    LoginSplash,
    {
      onClick: () => setFormState((prev) => ({ ...prev, splash: false })),
      loading: authenticating || authenticated
    }
  ) : mfa ? /* @__PURE__ */ jsx(MFARequired, {}) : appError2 ? /* @__PURE__ */ jsxs("div", { "aria-live": "polite", children: [
    /* @__PURE__ */ jsx("div", { className: "sa-login-text sa-login-error", children: "There was a problem logging you in, please try again" }),
    /* @__PURE__ */ jsx(Button, { className: "sa-login-button", onClick: onRetry, styling: "primary", children: "Retry" })
  ] }) : /* @__PURE__ */ jsxs(
    Form,
    {
      onSubmit: onAuth,
      className: "sa-login-form row column",
      "aria-labelledby": "sa--login-username-password-title",
      children: [
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(H, { id: "sa--login-username-password-title", className: "title", children: "Log in to your account" }),
          authError2 && /* @__PURE__ */ jsxs("div", { className: "sa-login-error", "aria-live": "polite", children: [
            /* @__PURE__ */ jsx("img", { alt: "Error", src: InfoErrorIcon }),
            " ",
            authError2
          ] })
        ] }),
        /* @__PURE__ */ jsx(
          forwardRef,
          {
            autoFocus: true,
            className: "md-mar-top",
            onChange: (user) => setFormState((prev) => ({ ...prev, user })),
            value: formState.user,
            required: true,
            label: "Username",
            name: "username"
          }
        ),
        /* @__PURE__ */ jsx(
          forwardRef,
          {
            className: "md-mar-vertical",
            onChange: (pass) => setFormState((prev) => ({ ...prev, pass })),
            value: formState.pass,
            required: true,
            type: "password",
            label: "Password",
            name: "password"
          }
        ),
        /* @__PURE__ */ jsx(Button, { round: true, large: true, className: "sa-login-button md-mar-top", styling: "primary", children: authenticating || authenticated ? /* @__PURE__ */ jsx(ClipLoader, { color: "#fff", size: 20 }) : "Login" })
      ]
    }
  ) });
};
const Login = ({ appVersion }) => {
  const dispatch = useDispatchTyped();
  const identityManagement = useSelector((state) => state.app.identityManagement);
  const cognito = useSelector((state) => state.app.cognito);
  const instances = useSelector((state) => state.app.instances);
  const appInstance = useSelector((state) => state.app.instance);
  const loading = useSelector((state) => state.app.loading);
  const appConfig = useSelector((state) => state.app.appConfig);
  const [instance, setInstance] = useState(instances[0]);
  useEffect(() => {
    dispatch(initApp());
  }, []);
  const getLoginType = () => {
    return !identityManagement || identityManagement === "connect" || loading ? /* @__PURE__ */ jsx(LoginToken, {}) : identityManagement === "cognito" && (cognito == null ? void 0 : cognito.type) === "in_app" ? /* @__PURE__ */ jsx(LoginUsernamePassword, {}) : /* @__PURE__ */ jsx(LoginExternal, {});
  };
  const chooseInstance = () => {
    const url = `${window.location.search}&instanceKey=${instance.key}`;
    window.history.pushState("", "", url);
    dispatch(selectInstance(instance, appConfig));
    if (!identityManagement || identityManagement === "connect") {
      dispatch(login());
    }
  };
  const optioniseInstances = () => {
    return instances.map((instance2) => ({
      label: instance2.name,
      data: instance2
    }));
  };
  return /* @__PURE__ */ jsxs("main", { className: "sa-login", children: [
    /* @__PURE__ */ jsxs("div", { className: "panel sa-login-left", children: [
      /* @__PURE__ */ jsx("div", { className: "sa-login-logo", children: /* @__PURE__ */ jsx(H, { children: /* @__PURE__ */ jsx("img", { width: "230", src: Logo, alt: "Smart Agent", title: "Smart Agent" }) }) }),
      /* @__PURE__ */ jsxs(Level, { children: [
        /* @__PURE__ */ jsx("div", { className: "sa-login-body", children: loading ? /* @__PURE__ */ jsx(LoginSplash, { loading: true }) : appInstance ? getLoginType() : instances.length > 1 && /* @__PURE__ */ jsxs("div", { className: "row column auto", children: [
          /* @__PURE__ */ jsx("p", { children: "Let's get started" }),
          /* @__PURE__ */ jsx(
            forwardRef$1,
            {
              autoFocus: true,
              className: "md-mar-vertical",
              label: "Select Contact Centre",
              options: optioniseInstances(),
              onChange: (option) => setInstance(option.data),
              value: instance && instance.name
            }
          ),
          /* @__PURE__ */ jsx(Button, { large: true, round: true, styling: "primary", onClick: chooseInstance, children: "OK" })
        ] }) }),
        identityManagement && identityManagement !== "connect" && /* @__PURE__ */ jsx(
          "iframe",
          {
            title: "SmartAgent Login",
            src: (process.env.BASE_PATH || "") + "/iframe.html",
            id: "sa-login-iframe",
            className: "sa-login-iframe"
          }
        ),
        appVersion && /* @__PURE__ */ jsx("span", { className: "version", children: appVersion })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "panel sa-login-right", children: [
      /* @__PURE__ */ jsx("div", { className: "sa-login-slogan", children: /* @__PURE__ */ jsxs("p", { children: [
        /* @__PURE__ */ jsx("span", { children: "Your contact centre, reimagined " }),
        /* @__PURE__ */ jsx("span", { children: "to empower you with AI." })
      ] }) }),
      /* @__PURE__ */ jsx("div", { className: "sa-login-gamma-logo" })
    ] })
  ] });
};
export {
  globalReducer as A,
  initApp as B,
  user_actions as C,
  Login as L,
  userAuthenticated$1 as a,
  userAuthError as b,
  authenticatingUser as c,
  tokenError$1 as d,
  logout$1 as e,
  ccpLogout as f,
  userLoaded as g,
  requestToken as h,
  refreshToken as i,
  userError as j,
  authExternalUserRequest as k,
  login$1 as l,
  mfaRequired$1 as m,
  setCallProviderInitStartTime as n,
  authError as o,
  submitMFA$1 as p,
  mfaRequired as q,
  requestingToken as r,
  selectInstance$1 as s,
  tokenRequested as t,
  userLoaded$1 as u,
  validatingToken as v,
  authenticateUser as w,
  preLoginInitAppSuccess as x,
  appReducer as y,
  userReducer as z
};
